The success result for the `createWebhookSubscription` mutation.
